import { Button, Spinner } from "react-bootstrap";

const Pressable = (props) => {
  let { onPress, title, titleStyle, classes, children, name, loading } = props;

  // Strip non-DOM props before spreading to avoid React warnings
  const { onPress: _op, title: _t, titleStyle: _ts, classes: _cl, name: _n, loading: _l, ...domProps } = props;

  return (
    <Button
      {...domProps}
      className={
        classes
          ? `${
              name === "curriculum" ? "Bg-curriculum" : "pressable"
            } ${classes}`
          : `pressable ${
              name === "curriculum" ? "Bg-curriculum" : "Bg-primary"
            }`
      }
      onClick={loading ? () => {} : onPress}
    >
      {loading && <Spinner className="spinner-border spinner-border-sm m-1" />}
      {!loading && title && (
        <span style={{ fontSize: "14px", ...titleStyle }}>{title}</span>
      )}
      {children}
    </Button>
  );
};

export default Pressable;
